import { IntegrationLiveListType } from '@/types/integrations'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<IntegrationLiveListType>({
  pathCategory: 'integration_live_list_types',
})

export function useGetIntegrationLiveListType({
  id,
  ...options
}: UseGetDetailOptions<IntegrationLiveListType>) {
  const query = useGetDetail<IntegrationLiveListType>({
    id,
    queryKey: queryKeys.integrationLiveListTypes.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    integrationLiveListType: query.data,
    ...query,
  }
}

export function useGetIntegrationLiveListTypes({
  filters,
  ...options
}: UseGetListOptions<IntegrationLiveListType> = {}) {
  const query = useGetList<IntegrationLiveListType>({
    filters,
    queryKey: queryKeys.integrationLiveListTypes.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    integrationLiveListTypes: query.allData,
    ...query,
  }
}
